import React, { useState, Children } from 'react';
const BookingForm = () => {
  const [formData, setFormData] = useState({
    destination: '',
    departureDate: '',
    returnDate: '',
    adults: 1,
    children: 0,
    name: '',
    email: '',
    phone: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real app, you would submit the form data to a backend
    alert('Booking request submitted! We will contact you shortly.');
  };
  return <div className="py-16 bg-navy-900 text-white" data-id="element-230">
      <div className="container mx-auto px-4 md:px-8" data-id="element-231">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2" data-id="element-232">
          Quick Booking Request
        </h2>
        <p className="text-center text-gray-300 mb-10" data-id="element-233">
          Fill out the form below and our team will get back to you
        </p>
        <form onSubmit={handleSubmit} className="max-w-3xl mx-auto bg-navy-800 p-8 rounded-lg shadow-lg" data-id="element-234">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-235">
            <div data-id="element-236">
              <label htmlFor="destination" className="block mb-2 text-sm font-medium" data-id="element-237">
                Destination
              </label>
              <select id="destination" name="destination" value={formData.destination} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" required data-id="element-238">
                <option value="" data-id="element-239">Select Destination</option>
                <option value="umrah" data-id="element-240">Umrah Package</option>
                <option value="europe" data-id="element-241">Europe</option>
                <option value="asia" data-id="element-242">Asia</option>
                <option value="middleeast" data-id="element-243">Middle East</option>
                <option value="asean" data-id="element-244">ASEAN</option>
              </select>
            </div>
            <div data-id="element-245">
              <label htmlFor="departureDate" className="block mb-2 text-sm font-medium" data-id="element-246">
                Departure Date
              </label>
              <input type="date" id="departureDate" name="departureDate" value={formData.departureDate} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 text-white" required data-id="element-247" />
            </div>
            <div data-id="element-248">
              <label htmlFor="returnDate" className="block mb-2 text-sm font-medium" data-id="element-249">
                Return Date
              </label>
              <input type="date" id="returnDate" name="returnDate" value={formData.returnDate} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 text-white" required data-id="element-250" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-251">
              <div data-id="element-252">
                <label htmlFor="adults" className="block mb-2 text-sm font-medium" data-id="element-253">
                  Adults
                </label>
                <input type="number" id="adults" name="adults" min="1" value={formData.adults} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 text-white" required data-id="element-254" />
              </div>
              <div data-id="element-255">
                <label htmlFor="children" className="block mb-2 text-sm font-medium" data-id="element-256">
                  Children
                </label>
                <input type="number" id="children" name="children" min="0" value={formData.children} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 text-white" data-id="element-257" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-258">
            <div data-id="element-259">
              <label htmlFor="name" className="block mb-2 text-sm font-medium" data-id="element-260">
                Full Name
              </label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 text-white" required data-id="element-261" />
            </div>
            <div data-id="element-262">
              <label htmlFor="email" className="block mb-2 text-sm font-medium" data-id="element-263">
                Email
              </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 text-white" required data-id="element-264" />
            </div>
            <div data-id="element-265">
              <label htmlFor="phone" className="block mb-2 text-sm font-medium" data-id="element-266">
                Phone
              </label>
              <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-navy-700 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 text-white" required data-id="element-267" />
            </div>
          </div>
          <div className="text-center" data-id="element-268">
            <button type="submit" className="bg-gold-500 hover:bg-gold-600 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-269">
              Submit Booking Request
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default BookingForm;